import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/logo.png";
import { FaWarehouse, FaBars, FaTimes, FaChevronLeft, FaChevronRight, FaUserTie } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { MdDashboard, MdHealthAndSafety, MdOutlineRoute, MdDirectionsCar, MdDevices, MdStore } from "react-icons/md";
import { MdLogin, MdLogout } from "react-icons/md";

import { HiOutlineClipboardList } from "react-icons/hi";
import "./sideBar.css";

const menuItems = [
  { path: "/", icon: <MdDashboard size={20} color="#5E72E4" />, text: "Dashboard" },
  { path: "/health", icon: <MdHealthAndSafety size={20} color="#5E72E4" />, text: "Health" },
  { path: "/bay-info", icon: <FaWarehouse size={18} color="#5E72E4" />, text: "Bay Info" },
  { path: "/device", icon: <MdDevices size={20} color="#5E72E4" />, text: "Device" },
  { path: "/shop", icon: <MdStore size={20} color="#5E72E4" />, text: "Shop" },
  { path: "/bay", icon: <FaWarehouse size={18} color="#5E72E4" />, text: "Bay" },
  { path: "/trip", icon: <MdOutlineRoute size={20} color="#5E72E4" />, text: "Trip" },
  { path: "/vehicle_schedule", icon: <MdDirectionsCar size={20} color="#5E72E4" />, text: "Vehicle Logs" },
  { path: "/vehicle_info", icon: <MdDirectionsCar size={20} color="#5E72E4" />, text: "Vehicle Info" },
  { path: "/employee", icon: <FaUserTie size={20} color="#5E72E4" />, text: "Employee" },
  { path: "/vendor", icon: <FiUsers size={20} color="#5E72E4" />, text: "Vendor" },
  { path: "/vehicleentry", icon: <MdLogin size={20} color="#5E72E4" />, text: "Entry Gate" },
  { path: "/parkingexit", icon: <MdLogout size={20} color="#5E72E4" />, text: "Parking Exit" },

];

const SideBar = ({ isCollapsed, setIsCollapsed }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setShowMobileMenu(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) setIsCollapsed((prev) => !prev);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const renderMenuItems = () => {
    return menuItems.map((item, index) => (
      <NavLink
        key={index}
        to={item.path}
        className={({ isActive }) =>
          `admin-nav-link ${isActive ? "active-page" : ""} ${isCollapsed && !isMobile ? "collapsed" : ""}`
        }
        onClick={() => isMobile && setShowMobileMenu(false)}
      >
        <div className="nav-icon">{item.icon}</div>
        <span className="menu-text">{item.text}</span>
      </NavLink>
    ));
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      {isMobile && (
        <button className="mobile-toggle" style={{ zIndex: "1000" }} onClick={toggleMobileMenu}>
          {showMobileMenu ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      )}

      {/* Overlay for Mobile Menu */}
      <div className={`sidebar-overlay ${showMobileMenu ? "show" : ""}`} onClick={toggleMobileMenu}></div>

      {/* Sidebar */}
      <aside className={`sidebar ${isCollapsed && !isMobile ? "collapsed" : ""} ${showMobileMenu ? "mobile-show" : ""}`}>
        <div className="sidebar-header">
          <img
            src={isCollapsed && !isMobile ? "/maruti-suzuki-india--600.png" : logo}
            alt="logo"
            className={`logo ${isCollapsed ? "small" : ""}`}
          />
          {!isMobile && (
            <button className="collapse-btn" onClick={toggleSidebar}>
              {isCollapsed ? <FaChevronRight size={16} /> : <FaChevronLeft size={16} />}
            </button>
          )}
        </div>

        {/* Menu Items */}
        <nav className="sidebar-nav">{renderMenuItems()}</nav>

        <div className="sidebar-footer">{/* Optional Footer Content */}</div>
      </aside>
    </>
  );
};

export default SideBar;
